import removeUSA from './removeUSA';

const getCityStateZipFromFormattedAddress = (formattedAddress: string) => {
  const regex = /^[A-Za-z\s]+,\s*[A-Za-z]{2}\s*\d{5},\s*USA$/;
  if (regex.test(formattedAddress)) {
    return removeUSA(formattedAddress);
  }
  return formattedAddress
    .split(',')
    .slice(1, 3)
    .map((comp: string) => comp.trim())
    .join(', ');
};

export default getCityStateZipFromFormattedAddress;
